export default {
  notifications: {
    fetchFailed: {
      title: 'An error occurred',
      message: 'Failed to load shipping address information',
    },
    updateFailed: {
      title: 'An error occurred',
      message: 'Failed to update shipping address information',
    },
    updateSuccess: {
      title: 'Update',
      message: 'Shipping information updated',
    },
    defaultError: {
      title: 'An error occurred',
      message: 'Please try again.',
    },
  },
};
